import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import api from '../api/axios';
import { useLanguage } from '../context/LanguageContext';
import { useAuth } from '../context/AuthContext';

export const GoogleCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useLanguage();
  const { setUser, loadProjects } = useAuth();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const code = searchParams.get('code');
        const state = searchParams.get('state');

        if (!code) {
          toast.error(t.authorizationCodeNotFound || 'Authorization code not found');
          navigate('/login');
          return;
        }

        // Backend'e callback gönder
        const response = await api.post('/auth/google/callback', {
          code,
          state
        });

        const { access_token, user } = response.data;

        // Token ve user bilgisini localStorage'a kaydet
        localStorage.setItem('token', access_token);
        localStorage.setItem('user', JSON.stringify(user));

        // AuthContext'in user state'ini güncelle
        if (setUser) {
          setUser(user);
        }

        // AuthContext'in loadProjects fonksiyonunu kullan
        if (loadProjects) {
          await loadProjects(null);
        }

        // Başarı mesajı göster
        toast.success(t.loginSuccess || 'Login successful!');

        // Dashboard'a yönlendir
        navigate('/dashboard');
      } catch (error) {
        console.error('Google OAuth callback error:', error);
        const errorMessage = error.response?.data?.detail || t.googleLoginError || 'Google login failed';
        toast.error(errorMessage);

        // Login page'ine yönlendir
        navigate('/login');
      }
    };

    handleCallback();
  }, [searchParams]);

  return (
    <>
      <Helmet>
        <title>Signing In with Google - FeedPanels</title>
        <meta name="description" content="Completing Google sign-in for FeedPanels. You will be redirected to your dashboard shortly." />
        <link rel="canonical" href="https://feedpanels.com/auth/google/callback" />
      </Helmet>
      <div className="flex items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 dark:border-white"></div>
        <p className="mt-4 text-gray-600 dark:text-gray-400">
          {t.signingInWithGoogle || "Signing in with Google..."}
        </p>
      </div>
    </div>
    </>
  );
};
